AppRun.$inject = ["$rootScope", "$cookies", "$location"];

function AppRun(rootScope, cookies, $location) {

    // var auth = async function () {
    //     let locationHash =  $location.path();
    //     var claims =  cookies.getObject('cached-claims')
    //     if (locationHash == '/auth/clear') {
    //         console.log("logout-callback");
    //     }
    //     else if (locationHash.startsWith('/auth/callback')) {
    //         console.log("login-callback");
    //     }
    //     else {
    //         let token = cookies.getObject('accessToken')
    //         if (token) {
    //             if (claims.user_type == 'Individual') {
    //                 location.hash = "";
    //                 location.pathname = "Individual";
    //             }
    //             else if (claims.user_type == 'Legal') {
    //                 location.hash = "";
    //                 location.pathname = "Legal";
    //             }
    //             else {
    //                 location.hash = "";
    //                 location.pathname = "Admin";
    //             }
    //         }
    //     }
    // }

    // rootScope.$on('$locationChangeStart', function (event, next, current) {
    //     auth()
    // });

    // alert(getQuerystringNameValue("guestUrl"));


}

export default AppRun;
